import { memo } from 'react'
import { baseInputClasses, labelClasses } from '../../styles/inputStyles'

/**
 * AnnouncementScheduling - Date scheduling and publishing controls
 * Includes start/end dates and published checkbox
 */
const AnnouncementScheduling = memo(function AnnouncementScheduling({
  formData,
  onChange
}) {
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="startDate" className={labelClasses}>
            Start Date
          </label>
          <input
            type="datetime-local"
            id="startDate"
            name="startDate"
            value={formData.startDate}
            onChange={onChange}
            className={baseInputClasses}
          />
        </div>

        <div>
          <label htmlFor="endDate" className={labelClasses}>
            End Date
          </label>
          <input
            type="datetime-local"
            id="endDate"
            name="endDate"
            value={formData.endDate}
            onChange={onChange}
            className={baseInputClasses}
          />
        </div>
      </div>

      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            name="isPublished"
            checked={formData.isPublished}
            onChange={onChange}
            className="rounded border-gray-300 text-primary focus:ring-primary mr-2"
          />
          <span className="text-sm font-medium text-gray-700">Published</span>
        </label>
        <p className="text-xs text-gray-500 mt-1">
          Unpublished announcements will not be visible to users
        </p>
      </div>
    </>
  )
})

export default AnnouncementScheduling
